// @generated by protoc-gen-connect-es v1.6.1 with parameter "target=js+dts"
// @generated from file booking_gateway/v1/reservations.proto (package booking_gateway.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { CancelSeatsRequest, CancelSeatsResponse, ReserveSeatsRequest, ReserveSeatsResponse } from "./reservations_pb.js";
import { MethodKind } from "@bufbuild/protobuf";
import { CancelBundleRequest, CancelBundleResponse, ReserveBundleRequest, ReserveBundleResponse } from "../../booking/types/v1/reservation_pb.js";

/**
 * @generated from service booking_gateway.v1.Reservations
 */
export const Reservations = {
  typeName: "booking_gateway.v1.Reservations",
  methods: {
    /**
     * ReserveSeats tries to reserve the given seats in a section.
     * If there is already a reservation a reservation token must be provided
     * that identifies this reservation. Otherwise a new reservation will be
     * created and the reservation token returned.
     *
     * @generated from rpc booking_gateway.v1.Reservations.ReserveSeats
     */
    reserveSeats: {
      name: "ReserveSeats",
      I: ReserveSeatsRequest,
      O: ReserveSeatsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * CancelSeats tries to release the given seats from a reservation.
     * For cancelling seats a reservation token is necessary. Cancelling
     * without such a token (i.e. without an existing reservation) does
     * not do anything.
     *
     * @generated from rpc booking_gateway.v1.Reservations.CancelSeats
     */
    cancelSeats: {
      name: "CancelSeats",
      I: CancelSeatsRequest,
      O: CancelSeatsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc booking_gateway.v1.Reservations.ReserveBundle
     */
    reserveBundle: {
      name: "ReserveBundle",
      I: ReserveBundleRequest,
      O: ReserveBundleResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc booking_gateway.v1.Reservations.CancelBundle
     */
    cancelBundle: {
      name: "CancelBundle",
      I: CancelBundleRequest,
      O: CancelBundleResponse,
      kind: MethodKind.Unary,
    },
  }
};

